// Ravalement par arrondissement parisien — pages locales hyper-ciblées.
// Contenu factuel et distinct par arrondissement (bâti, contraintes réelles),
// sans données inventées. Réutilise le gabarit LocalPage.
import { PARIS_IMG } from './serviceImages';

export const ARRONDISSEMENTS = [
  {
    slug: 'paris-8e',
    path: '/ravalement-facade-paris-8e',
    name: 'Paris 8e',
    department: 'Paris 8e · 75008',
    image: PARIS_IMG,
    metaTitle: 'Ravalement de façade à Paris 8e (75008) | VIREO',
    metaDescription:
      "Entreprise de ravalement de façade dans le 8e arrondissement de Paris : immeubles haussmanniens en pierre de taille, copropriétés de prestige, isolation par l’extérieur. Étude et devis gratuits.",
    h1: 'Ravalement de façade à Paris 8e',
    primaryKeyword: 'ravalement façade Paris 8e',
    secondaryKeywords: ['façadier Paris 8e', 'ravalement immeuble 8e arrondissement'],
    intro:
      "Dans le 8e arrondissement, VIREO réalise le ravalement des façades, l’isolation par l’extérieur et la rénovation d’immeubles haussmanniens et de copropriétés.",
    context: [
      "Le 8e arrondissement — des Champs-Élysées au parc Monceau — se distingue par ses immeubles haussmanniens en pierre de taille et ses façades de prestige. Leur ravalement exige des finitions soignées : nettoyage adapté, reprise des modénatures et enduits respectueux du bâti.",
      "Dans ce secteur dense et patrimonial, nous anticipons dès l’étude la logistique d’un chantier parisien : échafaudage, autorisation d’occupation du domaine public, coordination avec le syndic et respect des prescriptions applicables.",
    ],
    faq: [
      {
        q: 'Intervenez-vous sur les immeubles haussmanniens du 8e ?',
        a: "Oui. Le ravalement de la pierre de taille et la reprise des modénatures font partie de nos interventions courantes sur le bâti haussmannien.",
      },
      {
        q: 'Gérez-vous l’échafaudage sur la voirie ?',
        a: "Oui, nous intégrons les démarches d’occupation du domaine public et la sécurisation du chantier dans notre organisation.",
      },
    ],
  },
  {
    slug: 'paris-16e',
    path: '/ravalement-facade-paris-16e',
    name: 'Paris 16e',
    department: 'Paris 16e · 75016',
    image: PARIS_IMG,
    metaTitle: 'Ravalement de façade à Paris 16e (75016) | VIREO',
    metaDescription:
      "Ravalement de façade dans le 16e arrondissement de Paris : immeubles haussmanniens, façades Art déco et Art nouveau, hôtels particuliers de Passy et d’Auteuil. Devis gratuit.",
    h1: 'Ravalement de façade à Paris 16e',
    primaryKeyword: 'ravalement façade Paris 16e',
    secondaryKeywords: ['façadier Paris 16e', 'ravalement hôtel particulier Auteuil'],
    intro:
      "VIREO ravale et rénove les façades du 16e arrondissement : immeubles résidentiels, hôtels particuliers et bâti remarquable de Passy et d’Auteuil.",
    context: [
      "Le 16e arrondissement associe un bâti haussmannien cossu à un patrimoine Art nouveau et Art déco, notamment dans les secteurs d’Auteuil et de Passy, ponctué d’hôtels particuliers. Ces façades demandent des traitements respectueux de leurs matériaux et de leurs décors.",
      "Nous adaptons nos procédés à chaque type de façade — pierre, brique, enduit, éléments sculptés — en préservant le caractère architectural du quartier.",
    ],
    faq: [
      {
        q: 'Rénovez-vous les façades Art déco et Art nouveau ?',
        a: "Oui, nous intervenons sur ces façades en préservant leurs décors et en choisissant des finitions compatibles avec leurs matériaux.",
      },
      {
        q: 'Travaillez-vous sur les hôtels particuliers ?',
        a: "Oui, du diagnostic à la réalisation, en adaptant nos techniques au bâti de caractère.",
      },
    ],
  },
  {
    slug: 'paris-17e',
    path: '/ravalement-facade-paris-17e',
    name: 'Paris 17e',
    department: 'Paris 17e · 75017',
    image: PARIS_IMG,
    metaTitle: 'Ravalement de façade à Paris 17e (75017) | VIREO',
    metaDescription:
      "Ravalement de façade dans le 17e arrondissement de Paris : de la plaine Monceau haussmannienne aux Batignolles et au quartier Clichy-Batignolles. Copropriétés, isolation par l’extérieur. Devis gratuit.",
    h1: 'Ravalement de façade à Paris 17e',
    primaryKeyword: 'ravalement façade Paris 17e',
    secondaryKeywords: ['façadier Paris 17e', 'ravalement Batignolles'],
    intro:
      "Dans le 17e, VIREO ravale et isole les façades d’un arrondissement contrasté, de la plaine Monceau aux Batignolles.",
    context: [
      "Le 17e arrondissement juxtapose la plaine Monceau, cossue et haussmannienne, les Batignolles et les Épinettes, plus populaires, et le quartier récent de Clichy-Batignolles. Cette diversité se traduit par des façades très variées, de la pierre de taille au bâti plus récent.",
      "Selon le bâtiment, nous proposons un ravalement traditionnel ou une isolation thermique par l’extérieur, en coordination avec les copropriétés.",
    ],
    faq: [
      {
        q: 'Proposez-vous l’ITE dans le 17e ?',
        a: "Oui, l’isolation par l’extérieur est pertinente sur de nombreux immeubles du 17e ; nous l’étudions selon la façade et les contraintes locales.",
      },
      {
        q: 'Accompagnez-vous les copropriétés du 17e ?',
        a: "Oui, nous répondons aux consultations de syndics et coordonnons les travaux de ravalement et d’isolation.",
      },
    ],
  },
  {
    slug: 'paris-7e',
    path: '/ravalement-facade-paris-7e',
    name: 'Paris 7e',
    department: 'Paris 7e · 75007',
    image: PARIS_IMG,
    metaTitle: 'Ravalement de façade à Paris 7e (75007) | VIREO',
    metaDescription:
      "Ravalement de façade dans le 7e arrondissement de Paris : bâti de prestige en pierre de taille, abords de monuments et secteurs suivis par les Architectes des Bâtiments de France. Devis gratuit.",
    h1: 'Ravalement de façade à Paris 7e',
    primaryKeyword: 'ravalement façade Paris 7e',
    secondaryKeywords: ['façadier Paris 7e', 'ravalement pierre de taille Invalides'],
    intro:
      "VIREO ravale les façades du 7e arrondissement, un secteur patrimonial de prestige autour des Invalides et du Champ-de-Mars.",
    context: [
      "Le 7e arrondissement — Invalides, Champ-de-Mars, Gros-Caillou — réunit un bâti de prestige en pierre de taille dans un environnement monumental. De nombreux immeubles se situent aux abords de monuments historiques.",
      "Dans ces secteurs, les travaux de façade peuvent relever de l’avis des Architectes des Bâtiments de France. Nous intégrons ces contraintes et soignons les finitions traditionnelles.",
    ],
    faq: [
      {
        q: 'Les contraintes ABF s’appliquent-elles dans le 7e ?',
        a: "Aux abords des monuments historiques, les travaux de façade peuvent nécessiter l’avis des Architectes des Bâtiments de France. Nous en tenons compte dès l’étude.",
      },
      {
        q: 'Travaillez-vous la pierre de taille ?',
        a: "Oui : nettoyage adapté, reprise des joints et des modénatures font partie de nos interventions sur la pierre.",
      },
    ],
  },
  {
    slug: 'paris-15e',
    path: '/ravalement-facade-paris-15e',
    name: 'Paris 15e',
    department: 'Paris 15e · 75015',
    image: PARIS_IMG,
    metaTitle: 'Ravalement de façade à Paris 15e (75015) | VIREO',
    metaDescription:
      "Ravalement de façade dans le 15e arrondissement de Paris : bâti varié, immeubles haussmanniens, des années 1930 et ensembles plus récents (Front de Seine). Copropriétés, isolation. Devis gratuit.",
    h1: 'Ravalement de façade à Paris 15e',
    primaryKeyword: 'ravalement façade Paris 15e',
    secondaryKeywords: ['façadier Paris 15e', 'ravalement copropriété 15e'],
    intro:
      "Dans le 15e, le plus peuplé des arrondissements parisiens, VIREO ravale et isole les façades d’un bâti varié, pour les copropriétés comme pour les particuliers.",
    context: [
      "Le 15e arrondissement présente un bâti particulièrement varié : immeubles haussmanniens, constructions des années 1930 et ensembles plus récents comme le Front de Seine (Beaugrenelle). Chaque époque appelle une approche de ravalement spécifique.",
      "Pour les grandes copropriétés, nous structurons l’étude, le chiffrage et le suivi du chantier, et proposons l’isolation par l’extérieur lorsqu’elle est adaptée.",
    ],
    faq: [
      {
        q: 'Intervenez-vous sur les grandes copropriétés du 15e ?',
        a: "Oui, nous accompagnons les copropriétés et les syndics, de la consultation au suivi de chantier.",
      },
      {
        q: 'Peut-on associer ravalement et isolation ?',
        a: "Oui, coupler ravalement et ITE permet de mutualiser l’échafaudage et d’améliorer la performance thermique en une seule opération.",
      },
    ],
  },
  {
    slug: 'paris-11e',
    path: '/ravalement-facade-paris-11e',
    name: 'Paris 11e',
    department: 'Paris 11e · 75011',
    image: PARIS_IMG,
    metaTitle: 'Ravalement de façade à Paris 11e (75011) | VIREO',
    metaDescription:
      "Ravalement de façade dans le 11e arrondissement de Paris : immeubles de rapport du XIXe, anciens faubourgs (Bastille, faubourg Saint-Antoine), cours et ateliers. Copropriétés. Devis gratuit.",
    h1: 'Ravalement de façade à Paris 11e',
    primaryKeyword: 'ravalement façade Paris 11e',
    secondaryKeywords: ['façadier Paris 11e', 'ravalement immeuble Bastille'],
    intro:
      "VIREO ravale et rénove les façades du 11e arrondissement, quartier dense et vivant des faubourgs de l’est parisien.",
    context: [
      "Le 11e arrondissement — Bastille, République, faubourg Saint-Antoine — est l’un des plus denses de Paris. Son bâti est marqué par les immeubles de rapport de la fin du XIXe siècle et par les cours et ateliers de l’ancien quartier du meuble.",
      "Ces façades, souvent enduites, demandent des reprises adaptées. Nous organisons le chantier en tenant compte de la densité du quartier et de la vie des copropriétés.",
    ],
    faq: [
      {
        q: 'Rénovez-vous les immeubles de rapport du 11e ?',
        a: "Oui, nous ravalons les façades enduites et en pierre des immeubles anciens, avec des finitions adaptées au support.",
      },
      {
        q: 'Comment gérez-vous un chantier en secteur dense ?',
        a: "Nous anticipons l’échafaudage, l’occupation du domaine public et l’information des occupants dès l’étude.",
      },
    ],
  },
];

export const getArrondissementBySlug = (slug) => ARRONDISSEMENTS.find((a) => a.slug === slug);
